module.exports = __webpack_public_path__ + "static/assets/74e3c6dbadaaa2eb8b156e2d320b1208.jpg";